import { Component } from '@angular/core';

@Component({
  selector: 'app-receipt-cancellationlanding',
  templateUrl: './receipt-cancellationlanding.component.html',
  styleUrls: ['./receipt-cancellationlanding.component.scss']
})
export class ReceiptCancellationlandingComponent {

}
